import { getTestPort } from "@/utils/common";
const VUE_APP_URL_API = getTestPort();
const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getTestOrdeList({ rootState }, params = {}) {
      const data = await rootState.http(VUE_APP_URL_API + "/opCheckOrder/queryOrderList", params);
      return data;
    },
    async getTestOrderDetail({ rootState }, params = {}) {
      const data = await rootState.http(VUE_APP_URL_API + "/opCheckOrder/queryCheckOrder", params);
      return data;
    },
  }
};

export default store;
